import { captureException } from '@sentry/browser';
import { AxiosError } from 'axios';
import { useState } from 'react';

import { TOrder } from '@/types/orders';

import { TErrorData, getPreviousOrders } from '@/shared/api';
import { useShowTechnicalError } from '@/shared/hooks/use-show-technical-error';

type TReturnedGetPreviousOrders = {
    previousOrders: TOrder[];
    isRequested: boolean;
    handlePreviousOrders: (key: string) => void;
};

export const useGetPreviousOrders = (): TReturnedGetPreviousOrders => {
    const [previousOrders, setPreviousOrders] = useState<TOrder[]>([]);

    const [isRequested, setIsRequested] = useState<boolean>(false);

    const { showError } = useShowTechnicalError();

    const handlePreviousOrders = async (key: string) => {
        if (!isRequested && key === 'item-2') {
            try {
                const responseOrders = await getPreviousOrders();

                setPreviousOrders(responseOrders);

                setIsRequested(true);
            } catch (err) {
                const error = err as AxiosError;

                const response = error.response?.data as TErrorData;

                captureException(error);

                showError(response?.message);

                setIsRequested(true);
            }
        }
    };

    return {
        handlePreviousOrders,
        isRequested,
        previousOrders,
    };
};
